// src/scripts/tasks/tasksApi.js

import {
  httpsCallable,
} from "firebase/functions";

import {
  functions,
} from "@/firebase";

/* =========================================================
   CALLABLES
========================================================= */

const getBoardCallable =
  httpsCallable(
    functions,
    "taskBoardGet"
  );

const saveBoardCallable =
  httpsCallable(
    functions,
    "taskBoardSave"
  );

/* =========================================================
   GET TASK BOARD
========================================================= */

export async function getTaskBoard(
  venueId
) {
  const resolvedVenueId =
    String(
      venueId ||
      ""
    ).trim();

  if (
    !resolvedVenueId
  ) {
    throw new Error(
      "Venue ID is required."
    );
  }

  const response =
    await getBoardCallable({
      venueId:
        resolvedVenueId,
    });

  const data =
    response?.data ||
    {};

  if (
    data.ok !==
      true ||
    !data.board
  ) {
    throw new Error(
      "Task board could not be loaded."
    );
  }

  return data.board;
}

/* =========================================================
   SAVE TASK BOARD
========================================================= */

export async function saveTaskBoard(
  venueId,
  board
) {
  const resolvedVenueId =
    String(
      venueId ||
      ""
    ).trim();

  if (
    !resolvedVenueId
  ) {
    throw new Error(
      "Venue ID is required."
    );
  }

  if (
    !board ||
    typeof board !==
      "object"
  ) {
    throw new Error(
      "Task board is required."
    );
  }

  try {
    const response =
      await saveBoardCallable({
        venueId:
          resolvedVenueId,

        board,
      });

    const data =
      response?.data ||
      {};

    if (
      data.ok !==
      true
    ) {
      throw new Error(
        "Task board could not be saved."
      );
    }

    return data;
  } catch (error) {
    if (
      error?.code ===
        "functions/aborted" ||
      String(
        error?.message ||
        ""
      ).includes(
        "TASK_BOARD_CONFLICT"
      )
    ) {
      const conflict =
        new Error(
          "TASK_BOARD_CONFLICT"
        );

      conflict.code =
        "TASK_BOARD_CONFLICT";

      conflict.serverRevision =
        error?.details
          ?.serverRevision ??
        null;

      throw conflict;
    }

    throw error;
  }
}